<template>
  <div :class="(info.isExitRow ? 'small-map-block' : 'map-block') + ' exit exit-' + direction">
    <span class="exit-text"></span>
  </div>
</template>

<script>
export default {
  name: 'exit',
  props: {
    info: Object,
  },
  computed: {
    direction() {
      return this.info.direction;
    },
  },
};
</script>

<style lang="scss">
.exit {
  line-height: normal !important;
  color: white;
  text-align: center;
  display: flex;
  align-items: center;
  &-text {
    display: block;
    width: 100%;
    min-height: 2.5px;
    background-color: $available-seat-border;
  }
  &-left {
    align-items: flex-start;
    transform: rotate(-90deg);
  }
  &-right {
    margin-left: auto;
    align-items: flex-start;
    transform: rotate(90deg);
  }
}
</style>
